module.exports = require('@math.gl/web-mercator');
